import { getSessionStorage, setSessionStorage } from './sessionStorage';

import { VideoSetting } from '@interfaces/learning';

const VIDEO_SETTING_KEY = 'videoSetting';

export const setVideoSetting = (data: VideoSetting) => {
  setSessionStorage(VIDEO_SETTING_KEY, JSON.stringify(data));
};

export const getVideoSetting = () => {
  const videoSetting = getSessionStorage(VIDEO_SETTING_KEY);
  if (videoSetting) {
    return JSON.parse(videoSetting as string);
  }
  return null;
};
